<ng-content>
    <div
        [ngClass]="{
            toolbar: true,
            'toolbar-disabled': editorControl.disabled ?? false,
        }"
    >
        <button
            [disabled]="editorControl.disabled ?? false"
            type="button"
            (click)="execCommand('bold')"
            class="btn"
        >
            N
        </button>

        <button
            [disabled]="editorControl.disabled ?? false"
            type="button"
            (click)="execCommand('italic')"
            class="btn"
        >
            /
        </button>

        <button
            [disabled]="editorControl.disabled ?? false"
            type="button"
            (click)="execCommand('underline')"
            class="btn"
        >
            <u>S</u>
        </button>

        <span class="divider"></span>

        <button
            [disabled]="editorControl.disabled ?? false"
            type="button"
            (click)="execAlign('left')"
            class="btn"
        >
            <i class="fa-solid fa-align-left"></i>
        </button>

        <button
            [disabled]="editorControl.disabled ?? false"
            type="button"
            (click)="execAlign('center')"
            class="btn"
        >
            <i class="fa-solid fa-align-center"></i>
        </button>

        <button
            [disabled]="editorControl.disabled ?? false"
            type="button"
            (click)="execAlign('right')"
            class="btn"
        >
            <i class="fa-solid fa-align-right"></i>
        </button>

        <span class="divider"></span>

        <button
            [disabled]="editorControl.disabled ?? false"
            type="button"
            (click)="execCommand('blockquote')"
            class="btn"
        >
            “
        </button>

        <button
            [disabled]="editorControl.disabled ?? false"
            type="button"
            (click)="toggleList('bullet')"
            class="btn"
        >
            <i class="fa-solid fa-list-ul"></i>
        </button>
    </div>

    <quill-editor
        #editor
        format="html"
        [modules]="{ toolbar: false }"
        [formControl]="editorControl"
        [ngClass]="{
            content: true,
            'content-disabled': editorControl.disabled ?? false,
        }"
    >
    </quill-editor>
</ng-content>
